import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import { UBLInvoiceitemsalmacen } from "./UBLInvoiceitemsalmacen";
import { Modal } from "../../../../../theme/Component/Modal";
import { CreateUBLInvoiceItems } from "../CreateUBLInvoice/CreateUBLInvoiveItem";
import { PrintJson } from "../../../../../theme/Component/PrintJson";



interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const RemoteComponentManageUBLInvoiceitems = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {


    const [lista, setLista] = useState<any>([]);
    const [ubl, setUbl] = useState<any>(null);




    useEffect(() => {
        if (properties) {
            setLista(properties.ProductList);
            if (properties.UBLInvoice) {
                setUbl(properties.UBLInvoice.DataBeanProperties);
            }
        }
    }, [properties])



    const submitForm = () => {

        let key: any = Object.keys(data);
        console.log({ [key[0]]: lista });
        // console.log(key[0].EditorObjectClassForName);


        if (setData) {
            setData({ [key[0]]: {} });
        }
    }


    return (
        <div className="row">
            {/* <PrintJson json={properties.UBLInvoice} /> */}


            <div className="col-md-12">
                {properties.UBLInvoice ?
                    <CreateUBLInvoiceItems _isAlmacen={true} idUBLInvoice={properties.UBLInvoice.DataBeanProperties.IDUBLInvoice} issueDate={properties.UBLInvoice.DataBeanProperties.IssueDate} _onChange={(e) => { }} />
                    // <UBLInvoiceitemsalmacen _idUBLInvoice={properties.UBLInvoice.DataBeanProperties.IDUBLInvoice} _issueDate={properties.UBLInvoice.DataBeanProperties.IssueDate} _invoice={properties.UBLInvoice.DataBeanProperties} />
                    :
                    <p>Sin elementos</p>
                }
            </div>

            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Siguiente</BasicButton>
            </div>

            <div className="col-md-12">

            </div>
        </div>
    )
}